export const DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';
export const GDAB2B_PAGE_NAME = 'GDAB2B';
export const GDA_PAGE_NAME = 'GDA';

export const RESYVALUE_MEMBER_URL = 'welcomecardmember';
export const GDA_MEMBER_URL = 'global-dining-access-member';
export const CENTURION_EVENT_TYPES = { WALK_IN: 1, RESERVATION: 2, API: 3 };

// USED IN LAYOUT CAROUSEL JSX
export const EVENT_CONTEXT = {
  EXPERIENTIAL_EVENTS: 'EXPERIENTIAL_EVENTS',
  PAST_EVENTS: 'PAST_EVENTS',
};

export const DEFAULT_CITY_CODE = 'ny';
export const DEFAULT_CITY_NAME = 'New York';
export const DEFAULT_CITY_SLUG = 'new-york-ny';
export const DEFAULT_COUNTRY = 'US';

export const DEFAULT_CITY_DATA = { code: DEFAULT_CITY_CODE, name: DEFAULT_CITY_NAME, slug: DEFAULT_CITY_SLUG };

export const GDA_ELIGIBLE = 'GDAEligible';
export const GDA_MEMBER = 'GDAMember';
export const GDA_COOKIE_NAME = 'GDA';

export const TERMS_FOLDER_NAME = 'TermsAndConditions';
export const TERMS_FILE_NAME = 'TermsAndConditionsData.json';

export const CTA_EVENT_NAME = 'click marketing cta';
export const ACQUISITION_CTA_EVENT_NAME = 'click acquisition cta';
export const CTA_BOOKING = 'click booking slot';

export const ERROR_EVENT_NAME = '';

export const CMT_COOKIE_NAME = 'CMType';
export const GOLD_CARD = 'GoldCard';

export const AMEX_UTM_SOURCE = 'web';
export const AMEX_DELTA_UTM_MEDIUM = 'delta';
export const AMEX_DELTA_UTM_BOOKING_CAMPAIGN = 'booking';
export const AMEX_DELTA_UTM_EDITORIAL_CAMPAIGN = 'editorial';
export const AMEX_MODAL = 'MODAL';

export const BREAKPOINTS = {
  SMALL: 576,
  MEDIUM: 768,
  LARGE: 992,
  XLARGE: 1200,
};
